var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTailedArrow = function SvgTailedArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.071 14.142"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.071 7.071L9.5 1.5 11 0l7.071 7.071L11 14.142l-1.5-1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6.071H0v2h16z"
  })));
};
export default SvgTailedArrow;